export function chromeRuntimeAvailable() {
  const { userAgent } = navigator

  // Handles using Chromium in E2E tests
  const isHeadlessBrowser = /HeadlessChrome/.test(userAgent)
  if (isHeadlessBrowser) return false

  return /Chrome/.test(userAgent) && !!chrome?.runtime?.sendMessage
}
